const offlineUser = () => import("@/views/offlineUser/offlineUser.vue");

export default [
	{
		path: '/offlineUser', // 下载
		name: 'offlineUser',
		component: offlineUser,
		meta: {
			title: '2041Mall',
			keepAlive: false
		}
	}
]